export enum PopoverDirection{
    down = 'down',
    up = 'up',
    right = 'rigth',
    left = 'left'
}
